import React from 'react';
import {Backdrop, Fade, Modal} from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import RadioButtons from '../../../components/customers/modal/createAudienceset'

const useStyles = makeStyles((theme) => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    borderRadius: '25px',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    zIndex: 1,
  },
}));

export default function TransitionsModal() {
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
      <div>
        <div onClick={handleOpen}>
          {/*react-transition-group*/}
          <img alt="component" src={require("../../../assets/images/Component 1.png").default}/>Create
          Audience
        </div>
        <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            className={classes.modal}
            open={open}
            onClose={handleClose}
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{
              timeout: 500,
            }}
        >

          <Fade in={open}>
            <div className={classes.paper}>
              <img alt="close" onClick={handleClose} className={'closeImg'}
                   src={require("../../../assets/images/Group41.png").default}/>
              <div className={'audienceBlock'}>
                <div className={'successfulImport'}>
                  <h2 id="simple-modal-title">Create Audience</h2>
                  <input className={'audienceName'} type={'text'}
                         placeholder={'Audience Name'}/>

                  <RadioButtons/>


                  <div className={'buttons'}>
                    <button onClick={handleClose} className={'yesDelete'}>
                      Create Audience
                    </button>
                    <button onClick={handleClose} className={'notDelete'}>
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </Fade>
        </Modal>
      </div>
  );
}

